import React from 'react';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import {
  ButtonProps,
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import LoadingSpinner from '@grnhse/seedling/lib/birch/components/loading_spinner';
import { CompactRow } from '@grnhse/seedling/lib/birch/layouts/compact_row';
const t = withLocalePrefix('candidate_profile_redesign.modals.email');

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

const LoadingModal = ({
  submitButtonText = t('save'),
  submitButtonIcon,
  secondSubmitButtonText = '',
  secondSubmitButtonIcon,
  modalTitle,
  maskTitle = false,
  type = 'default',
}: {
  submitButtonText?: string;
  submitButtonIcon?: ButtonProps['icon'];
  secondSubmitButtonText?: string;
  secondSubmitButtonIcon?: ButtonProps['icon'];
  modalTitle?: string;
  maskTitle?: boolean;
  type?: 'default' | 'two-submit-buttons';
}) => {
  return (
    <DataEntryModal
      size={'large'}
      isOpen={true}
      ariaLabel={'confirmation-modal'}
    >
      <DataEntryModal.Header onClick={() => Function.prototype}>
        {modalTitle ? (
          <span className={maskTitle ? 'pii-blur' : undefined}>
            {modalTitle}
          </span>
        ) : null}
      </DataEntryModal.Header>
      <DataEntryModal.Body>
        <LoadingContainer data-provides="loading-modal">
          <LoadingSpinner />
        </LoadingContainer>
      </DataEntryModal.Body>
      <DataEntryModal.Footer>
        {type === 'two-submit-buttons' ? (
          <CompactRow justifyContent="space-between" sx={{ margin: 0 }}>
            <SecondaryButton onClick={() => Function.prototype} disabled={true}>
              {t('cancel')}
            </SecondaryButton>
            <CompactRow sx={{ margin: 0 }}>
              <PrimaryButton disabled={true} icon={submitButtonIcon}>
                {submitButtonText}
              </PrimaryButton>
              <PrimaryButton disabled={true} icon={secondSubmitButtonIcon}>
                {secondSubmitButtonText}
              </PrimaryButton>
            </CompactRow>
          </CompactRow>
        ) : (
          <>
            <Grid item>
              <SecondaryButton
                onClick={() => Function.prototype}
                disabled={true}
              >
                {t('cancel')}
              </SecondaryButton>
            </Grid>
            <Grid item>
              <PrimaryButton disabled={true} icon={submitButtonIcon}>
                {submitButtonText}
              </PrimaryButton>
            </Grid>
          </>
        )}
      </DataEntryModal.Footer>
    </DataEntryModal>
  );
};

export default LoadingModal;
